import React from 'react';
import { DocumentModel, ExcelDocument, Variant, VariantCode } from '../models';

export function useCreateProductAndVariant() {
  // States
  const [formState, setFormState] = React.useState<Partial<Variant>>({
    sku: '',
    stock: 0,
    price: 0,
    compareAtPrice: 0,
    agreedPrice: 0,
    option: {
      option1: '',
      option2: '',
      option3: '',
    },
    isOnline: false,
    expirationDate: null,
    codesAutogenerated: true,
    electronicCodes: [],
  });
  const [disabled, setDisabled] = React.useState<boolean>(false);
  const [addNewCodes, setAddNewCodes] = React.useState<boolean>(false);
  const [codesArray, setCodesArray] = React.useState<string[]>([]);
  const [isOnlineState, setIsOnlineState] = React.useState<boolean>(
    formState.isOnline
  );
  const [expirationDate, setExpirationDate] = React.useState<boolean>(false);
  const [documents, setDocuments] = React.useState<
    Array<Partial<DocumentModel>>
  >([]);

  // Handlers functions
  const handleChangeString = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: Number(value),
    });
  };

  const handleExpitationDateInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: new Date(value),
    });
  };

  const handleSetIsOnline = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      ...formState,
      isOnline: e.target.checked,
    });
  };

  const handleChangeAddNewCodes = () => {
    // Reset stock and codes
    setFormState({
      ...formState,
      stock: 0,
      codesAutogenerated: addNewCodes,
      expirationDate: null,
    });
    // Toggle
    setAddNewCodes((prev) => !prev);
  };

  const handleExcelDocument = (document: ExcelDocument) => {
    setCodesArray(document.tableRow.map((x: Partial<VariantCode>) => x.Codigo));
  };

  const handleExpirationDateInputChange = () => {
    setFormState({
      ...formState,
      expirationDate: null,
    });
    setExpirationDate((prev) => !prev);
  };

  // UseEffects
  React.useEffect(() => {
    if (addNewCodes) {
      setFormState({
        ...formState,
        stock: codesArray.length,
        electronicCodes: codesArray.map((code) => ({
          code,
          ...{ expirationDate: formState.expirationDate || null },
        })),
      });
    }
  }, [codesArray, formState.expirationDate]);

  React.useEffect(() => {
    setFormState({
      ...formState,
      isOnline: isOnlineState,
    });
  }, [isOnlineState]);

  return {
    // States
    formState,
    setFormState,
    disabled,
    setDisabled,
    addNewCodes,
    setAddNewCodes,
    codesArray,
    setCodesArray,
    isOnlineState,
    setIsOnlineState,
    expirationDate,
    setExpirationDate,
    documents,
    setDocuments,

    // Handlers functions
    handleChangeString,
    handleChangeNumber,
    handleExpitationDateInputChange,
    handleSetIsOnline,
    handleChangeAddNewCodes,
    handleExcelDocument,
    handleExpirationDateInputChange,
  };
}
